import MarkdownIt from 'markdown-it';
import mdHighlight from 'markdown-it-highlightjs';
var getMarkdownItInstance = function (role) {
    var md = MarkdownIt({
        breaks: true,
        html: true,
        linkify: true
    });
    // make all links open in a new tab
    md.renderer.rules.link_open = function (tokens, idx, options, _, self) {
        tokens[idx].attrSet('target', '_blank');
        return self.renderToken(tokens, idx, options);
    };
    return role === 'assistant' ? md.use(mdHighlight) : md;
};
var parseMarkdown = function (role, content) { return getMarkdownItInstance(role).render(content); };
export default parseMarkdown;
